import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    handlingLists: {
      id: 'pages.processHandlingList.breadcrumbs.handlingLists',
      defaultMessage: 'Handling lists',
      description: 'label of the handling lists breadcrumb',
    },
  },
  finishedAlert: {
    message: {
      id: 'pages.processHandlingList.finishedAlert.message',
      defaultMessage: 'This handling list is already finished',
      description: 'Message of the handling list already finished alert',
    },
    actions: {
      viewList: {
        id: 'pages.processHandlingList.finishedAlert.actions.viewList',
        defaultMessage: 'View list',
        description: 'Label of the view list action of the finished alert',
      },
    },
  },
  secondaryActions: {
    addItem: {
      id: 'pages.processHandlingList.secondaryActions.addItem',
      defaultMessage: 'Add item',
      description: 'Label of the secondary action add item',
    },
    history: {
      id: 'pages.processHandlingList.secondaryActions.history',
      defaultMessage: 'History',
      description: 'Label of the secondary action history',
    },
    pickAll: {
      id: 'pages.processHandlingList.secondaryActions.pickAll',
      defaultMessage: 'Pick all',
      description: 'Label of the secondary action pick all',
    },
    pickAndPackAll: {
      id: 'pages.processHandlingList.secondaryActions.pickAndPackAll',
      defaultMessage: 'Pick and pack all',
      description: 'Label of the secondary action pick and pack all',
    },
  },
};

export default defineMessages(translations);
